export default __webpack_public_path__ + "static/media/logo_crop.0f5a06a7.png";